import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Categoria } from 'my-lib-sanfelici';
import { CategorieService } from 'my-lib-sanfelici';


@Component({
  selector: 'app-categorie-by-marchio',
  templateUrl: './categorie-by-marchio.component.html',
  styleUrls: ['./categorie-by-marchio.component.css']
})
export class CategorieByMarchioComponent implements OnInit {
    categorie: Array< Categoria>;
    constructor(
        private categorieservice: CategorieService,
        private route: ActivatedRoute
      ) { }

  ngOnInit() {
      let id = this.route.snapshot.params['id'];
    //   this.categorieservice.getbyMarchio(id).subscribe((categorie: Array<Categoria>) => {

        //   this.categorie = categorie.filter(x => x.Attivo == true);
    //   });
  }

}
